import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationLink = _resolveComponent("NavigationLink")
  const _component_Navigation = _resolveComponent("Navigation")

  return (_openBlock(), _createBlock(_component_Navigation, { "show-login": true }, {
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
        return (_openBlock(), _createBlock(_component_NavigationLink, {
          key: route.title,
          "href-route": route.hrefRoute,
          href: route.href,
          "page-route": route.pageRoute,
          title: route.title,
          "not-a-link": route.notALink
        }, null, 8, ["href-route", "href", "page-route", "title", "not-a-link"]))
      }), 128))
    ]),
    _: 1
  }))
}